import { Container, makeStyles, Paper, Typography } from '@material-ui/core'
import { FC, useRef, useState } from 'react'
import useTranslate from '../i18n/useTranslate'
import Form from '../component/um/setting-faculty/Form'
import { useHistory } from 'react-router-dom'
import { FacultyFormType, useSettingFaculty } from '../services/um/useSettingFaculty'
import useAuthenStore from '../stores/authen/authenStore'
import Dialog, { DialogType } from '../control/dialog/dialog'
interface SettingFacultyAddProps {}
export type FormType = {
    nameTH: string | null
    nameEN: string | null
    rec: number | null
}
const SettingFacultyAdd: FC<SettingFacultyAddProps> = ({}) => {
    const classes = useStyle()
    const translate = useTranslate()
    const history = useHistory()
    const authenStore = useAuthenStore()

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const { postSettingFaculty } = useSettingFaculty()

    const save = async (values: FacultyFormType) => {
        const format = {
            ...values,
            userID: authenStore.profile.userId,
            recID: values.recID == 0 ? null : values.recID,
        }
        const result = await postSettingFaculty(format)
        let optionDialog: any = {
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
            type: 'alert-message',
            onAfterClose: onBack,
        }
        if (result.status !== 1) {
            optionDialog = {
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('MESSAGE.M022'),
                type: 'alert-message',
            }
        }

        setConfigDialog(optionDialog)
    }

    const onSubmit = (value: FacultyFormType) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => save(value),
        })

        dialogTwoRef.current?.openDialog()
    }

    const onBack = () => {
        history.goBack()
    }
    return (
        <Container maxWidth="lg">
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                {translate.get('UM.SETTING_FACULTY.ADD')}
            </Typography>
            <Paper className={classes.paper}>
                <Form onBack={onBack} onSubmit={onSubmit} />
            </Paper>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Container>
    )
}

const useStyle = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    paper: {
        width: '100%',
        padding: '20px',

        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
            margin: '0px',
        },
    },
}))

export default SettingFacultyAdd
